export const MODULE_NAME = 'exchange';

export const MAX_DECIMAL_SIZE = 8;
export const UPPER_BOUND = 10 ** MAX_DECIMAL_SIZE;
export const LOWER_BOUND = 1 / UPPER_BOUND;
